import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import baseTranslationsEN from './locales/en.json';
import actionsTranslationsEN from './locales/actions.json';
import translationRU from './locales/ru.json';
import placeholderTranslationsEN from './locales/placeholders.json';
import daysAvailableTranslationsEN from './components/daysAvailable/daysAvailableTranslationsEN.json';
import notificationsTranslationsEN from './locales/notifications.json';
import detector from 'i18next-browser-languagedetector';


const resources = {
  en: {
    translation: {
      ...baseTranslationsEN,
      ...actionsTranslationsEN,
      ...placeholderTranslationsEN,
      ...daysAvailableTranslationsEN,
      ...notificationsTranslationsEN
    },
  },
  ru: {
    translation: translationRU,
  },
};



i18n.use(detector).use(initReactI18next).init({
  resources,
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
